import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isUndefined, isEmpty } from 'underscore';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';
import * as driverActions from '../../../core/driver/driverActions';

function DriverPerformance({ singleDriver }) {
    let finalData = [];
    if (!isEmpty(singleDriver.journeyScore)) {
        finalData = singleDriver.journeyScore.map((item) => {
            const newItem = { ...item };
            if (!isUndefined(item.score)) {
                newItem['Weekly Average'] = item.score;
            }

            return newItem;
        });
    }

    return (
        <BarChart
            width={600}
            height={300}
            data={finalData}
            margin={{
                top: 5, 
                right: 30, 
                left: 20, 
                bottom: 5,
            }}
            style={{ marginLeft: '-32px' }}
        >
            <CartesianGrid strokeDasharray="1 1" />
            <XAxis dataKey="week" />
            <YAxis domain={[0, 100]} />
            <Legend />
            <Bar 
                dataKey="Weekly Average" 
                fill="#ff6900" 
            />
        </BarChart>
    );
}

DriverPerformance.propTypes = {
    singleDriver: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        singleDriver: state.driver.singleDriver,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...driverActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DriverPerformance);
